import LeadText from "@material-tailwind/react/LeadText";
import Input from "@material-tailwind/react/Input";
import Button from "@material-tailwind/react/Button";
import {Link} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {Heading4, Heading6, Small, Tooltips} from "@material-tailwind/react";
import H5 from "@material-tailwind/react/Heading5";
import {css} from "@emotion/react";
import ClipLoader from "react-spinners/DotLoader";
import TooltipsContent from "@material-tailwind/react/TooltipsContent";
import appStoreLogo from "assets/img/app/appcomingsoon.png"
import gplayLogo from "assets/img/gogleplay.png"
import apstorelayLogo from "assets/img/app/appstore.png"
import stripe from "assets/img/stripe.png"
import  app1 from "assets/img/app/app1.jpg"
import squareimag from "assets/img/vector-square-solid.svg"
import {borderStyle} from "tailwindcss/lib/plugins";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: blue;
`;
export default function Header(props) {
    const InputRef = useRef();
    let [loading, setLoading] = useState(false);
    let [color, setColor] = useState("#ffffff");

    let [text_, settext_] = useState("xxxx");

    useEffect(async () => {
        var requestOptions = {
            method: "GET",
            redirect: "follow",
        };

        fetch("https://sh2kml4ridealltiles.herokuapp.com/ping", requestOptions)
            .then((response) => response.text())
            .then((result) => console.log(result))
            .catch((error) => console.log("error", error));
    }, []);

    let pos =
        props.positionGlobal1.lat.toFixed(2) +
        "," +
        props.positionGlobal1.lng.toFixed(2);
    let linkVisited = `https://sh2kml4ridealltiles.herokuapp.com/Tile.kml?share_link=${props.shLink1}&homeCoordinates=${pos}&visited=1`;
    let linkVisitedText = `https://sh2kml4ridealltiles.herokuapp.com/Tile.kml?share_link=${props.shLink1}&homeCoordinates=${pos}&visited=1&astext=1`;

    return (
        <div className="relative pt-16 pb-32 flex content-center items-center justify-center h-screen">
            <div className="bg-landing-background bg-cover bg-center absolute top-0 w-full h-full " />
            {/*style={{border: '1px solid red '}}*/}
            <div className="container grid max-w-8xl relative mx-auto " >
                <div className="items-center flex flex-wrap" >

                    <div className="text-gray-200">

                        {/*<div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">*/}
                            <H5 color="white">
                              Tile Hunter
                            </H5>
                        <H5 color="white">
                            Never miss a square again
                        </H5>
                            <h3>Tools to help you collect squares
                                <div className="items-center flex flex-wrap">
                                    <a href="https://play.google.com/store/apps/details?id=com.squarehunters&hl=pl&gl=US">
                                        {/*<Image src="giticon.png" className="githubIcon" />*/}
                                        <img src={gplayLogo} style={{ height: '40px' }} alt="Logo"/>
                                    </a>



                                </div>
                                <div>

                                    <a href="https://play.google.com/store/apps/details?id=com.squarehunters&hl=pl&gl=US">
                                        {/*<Image src="giticon.png" className="githubIcon" />*/}
                                        <img src={apstorelayLogo} style={{ height: '40px' }} alt="Logo"/>
                                    </a>
                                </div>
                                <div>
                                    <p></p>
                                    <a href="https://www.youtube.com/watch?v=Cw0touHXyNU" target="_blank">
                                        {/*<Image src="giticon.png" className="githubIcon" />*/}
                                        {/*<img src={apstorelayLogo} style={{ height: '80px' }} alt="Logo"/>*/}
                                        See iOS app on Youtube
                                    </a>
                                </div>
                                <div>
                                    <small>
                                        Please consider small
                                        donation to get all the servers up and running{" "}
                                    </small>
                                    <div>
                                    <small>
                                       {/*Ps. If you supporting iOS app pls write it in comment{" "}*/}
                                    </small>
                                    </div>
                                    <div>
                                        <small>
                                            {/*5$ from 100$ to pay for Apple Developer account ;)*/}
                                        </small>
                                    </div>
                                    <a href="https://ko-fi.com/E1E26J6RH" target="_blank">
                                        <img
                                            style={{ height: '40px' }}
                                            height="6"
                                            src="https://cdn.ko-fi.com/cdn/kofi2.png?v=3"
                                            border="0"
                                            alt="Buy Me a Coffee at ko-fi.com"
                                        />
                                        {/*[20% commision]*/}
                                    </a>
                                    <a href="https://www.paypal.com/donate/?business=SGKNHANDTXPT4&no_recurring=0&currency_code=EUR" target="_blank">
                                        <img
                                            style={{ height: '40px' }}
                                            height="6"
                                            src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_SM.gif"
                                            border="0"
                                            alt="Buy Me a Coffee at ko-fi.com"
                                        />
                                        {/*[20% commision]*/}
                                    </a>
                                    {/*<div>*/}

                                        <a href="https://buy.stripe.com/5kAg0A1dw7oidK8eUV" target="_blank">
                                            <img src={stripe} style={{ height: '50px' }} alt="Logo"/>
                                        </a>
                                    {/*</div>*/}
                                </div>
                            </h3>
                        {/*</div>*/}

                        <h3>
                        {/*Best things in life are free*/}
                        </h3>

                    </div>


                </div>

                {/*<div className="items-center flex flex-wrap col-span-1 justify-center grid grid-rows-n">*/}

                {/*    <H5 color="white">*/}
                {/*    How to collect squares*/}
                {/*    </H5>*/}
                {/*    <div className="text-gray-200">*/}
                {/*       1 Record your activities on <a href="https://www.strava.com/">Strava</a>*/}
                {/*    </div>*/}
                {/*    /!*<p className="text-sm ...">The quick brown fox ...</p>*!/*/}
                {/*    /!*<p className="text-base ...">The quick brown fox ...</p>*!/*/}
                {/*    /!*<p className="text-lg text-gray-200">The quick brown fox ...</p>*!/*/}
                {/*    /!*<p className="text-xl  text-gray-200">The quick brown fox ...</p>*!/*/}
                {/*    /!*<p className="text-2xl ...">The quick brown fox ...</p>*!/*/}
                {/*    <div className="text-gray-200">*/}
                {/*        2 Login to amazing site : <a href="https://statshunters.com/">statshunters.com</a>*/}
                {/*    </div>*/}
                {/*    <div className="text-gray-200">*/}
                {/*        3 Download App on*/}
                {/*        <a href="https://play.google.com/store/apps/details?id=com.squarehunters">  PlayStore </a>*/}
                {/*          or AppStore [soon]*/}
                {/*    </div>*/}
                {/*    <div className="text-gray-200">*/}
                {/*        4 Login to   : <a href="https://statshunters.com/">statshunters.com</a>*/}
                {/*    </div>*/}
                {/*    <div className="text-gray-200">*/}
                {/*       5 Collect Squares*/}
                {/*        <img src={app1} style={{ height: '100px' }} alt="Logo"/>*/}
                {/*    </div>*/}
                {/*    <p className="text-gray-200"> More info about squares:</p>*/}
                {/*    <p className="text-gray-200">*/}
                {/*        <a href="https://blog.veloviewer.com/veloviewer-explorer-score-and-max-square/">blog.veloviewer.com</a>*/}
                {/*    </p>*/}
                {/*    <p className="text-gray-200">*/}
                {/*        <a href="https://rideeverytile.com/">rideeverytile</a>*/}
                {/*    </p>*/}
                {/*    <p className="text-gray-100">*/}
                {/*        <a href="https://www.statshunters.com/faq-10-what-are-explorer-tiles">statshunters</a>*/}
                {/*    </p>*/}
                {/*    <p className="text-gray-100">*/}
                {/*        <a href="https://www.statshunters.com/faq-10-what-are-explorer-tiles">statshunters</a>*/}
                {/*    </p>*/}




                {/*</div>*/}

            </div>

        </div>
    );
}
